import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
import React, { useRef } from "react";
import { usePlaygroundSlugs } from "#/shared/hooks";
import { useAppSelector } from "#/store/hooks";
import { useBrowseProjects } from "../../hooks/useBrowseProjects";
import { selectAccumulatedProjects } from "../../model/projectBrowserSlice";
import { ProjectBrowserCategoryBar } from "./ProjectBrowserCategoryBar";
import { useProjectBrowserContext } from "./ProjectBrowserContext";
import { ProjectBrowserHeader } from "./ProjectBrowserHeader";
import { ProjectBrowserList } from "./ProjectBrowserList";
type ProjectBrowserContentProps = {
  onSelectProject: (slug: string) => void;
  /** Optional ref for search input (e.g. for keyboard focus from parent) */
  searchInputRef?: React.RefObject<HTMLInputElement | null>;
};

/**
 * Shared browse content: category bar, search/filters header, and project list.
 * Used by both ProjectBrowser (drawer) and MobileBrowseView.
 */
export const ProjectBrowserContent: React.FC<ProjectBrowserContentProps> = t0 => {
  const $ = _c(16);
  const {
    onSelectProject,
    searchInputRef: searchInputRefProp
  } = t0;
  const {
    searchQuery,
    setSearchQuery
  } = useProjectBrowserContext();
  const {
    allBrief,
    browseProjects
  } = useBrowseProjects();
  const accumulatedProjects = useAppSelector(selectAccumulatedProjects);
  const {
    projectSlug: t1
  } = usePlaygroundSlugs();
  const projectSlug = t1 === undefined ? "" : t1;
  const internalSearchRef = useRef(null);
  const searchInputRef = searchInputRefProp ?? internalSearchRef;
  let t2;
  if ($[0] !== allBrief.data) {
    t2 = <ProjectBrowserCategoryBar projects={allBrief.data} />;
    $[0] = allBrief.data;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== searchInputRef || $[3] !== searchQuery || $[4] !== setSearchQuery) {
    t3 = <ProjectBrowserHeader searchValue={searchQuery} onSearchChange={setSearchQuery} searchInputRef={searchInputRef} />;
    $[2] = searchInputRef;
    $[3] = searchQuery;
    $[4] = setSearchQuery;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      flex: 1,
      overflow: "hidden"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== accumulatedProjects || $[8] !== browseProjects.isLoading || $[9] !== onSelectProject || $[10] !== projectSlug) {
    t5 = <Box sx={t4}><ProjectBrowserList projects={accumulatedProjects} isLoading={browseProjects.isLoading} selectedProjectSlug={projectSlug} onSelectProject={onSelectProject} /></Box>;
    $[7] = accumulatedProjects;
    $[8] = browseProjects.isLoading;
    $[9] = onSelectProject;
    $[10] = projectSlug;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <>{t2}{t3}{t5}</>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};